import { AutoComplete, Col, Form, Row } from "antd";
import Axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ReactComponent as Right } from "../../../static/arrowRight.svg";
import "./institution.scss";

const mapDispatchToProps = (dispatch) => {
  return {};
};

class ConnectedBasicDataInstitution extends Component {
  state = {
    name: "",
    selectedName: null,
    category: "",
    selectedCategory: null,
    institutions: [],
    categories: [],
  };

  componentDidMount = async () => {
    this.props.openKeyboard();
    await Axios.get("/1.0.0/game/institution")
      .then((response) => {
        this.setState({ institutions: response.data });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  handleChange = (event, option, stringName, selectedName) => {
    this.setState({ [stringName]: event, [selectedName]: option });
  };
  
  submitForm = async () => {
    this.props.next();
  };

  handleSelectInstitution = async (value, option) => {
    this.setState({ selectedName: option });
  };
  handleSelectCategory = (value, option) => {
    this.setState({ selectedCategory: option });
  };

  render() {
    const formItemLayout = {
      labelCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 24,
        },
      },
      wrapperCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 24,
        },
      },
    };
    return (
      <div>
        <div>
          <Form
            ref={this.props.formRef}
            {...formItemLayout}
            name="email"
            onFinish={this.submitForm}
            scrollToFirstError
            layout="vertical"
            //wrapperCol={{ style: { padding: "0", margin: "0 0 0 0" } }}
          >
            <Row>
              <Col span={18} style={{ padding: "1.5em" }}>
                <Form.Item
                  name="name"
                  rules={[
                    {
                      required: true,
                      message: "Kérem adja meg az intézmény nevét!",
                    },
                  ]}
                >
                  <AutoComplete
                    id="name"
                    name="name"
                    onChange={(value, option) =>
                      this.props.changeName(value, option)
                    }
                    onSelect={this.props.selectName}
                    value={this.props.name}
                    onFocus={this.props.setInputName}
                    style={{ width: "100%" }}
                    className="inst-input-field"
                    placeholder="Intézmény"
                  >
                    {this.state.institutions.map((institute) => {
                      return (
                        <AutoComplete.Option
                          key={institute.id}
                          value={institute.name}
                        >
                          {institute.name}
                        </AutoComplete.Option>
                      );
                    })}
                  </AutoComplete>
                  {/* <input
                    id="email"
                    name="email"
                    onChange={this.props.change}
                    value={this.props.email}
                    onFocus={this.props.setInputName}
                    style={{ width: "100%" }}
                    className="input-field"
                    placeholder="E-mail cím"
                  /> */}
                </Form.Item>
              </Col>
              <Col span={4} style={{ padding: "1.5em" }}>
                <Form.Item>
                  <button type="submit" className="inst-next-button">
                    Következő <Right className="inst-arrow-icon" />
                  </button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
          {/* <Form
            ref={this.props.formRef}
            {...formItemLayout}
            name="institution"
            onFinish={this.submitForm}
            scrollToFirstError
            layout="vertical"
            //wrapperCol={{ style: { padding: "0", margin: "0 0 0 0" } }}
          >
            <Form.Item
              label={<strong>Intézmény neve:</strong>}
              name="name"
              rules={[
                {
                  required: true,
                  message: "Kérem adja meg az intézmény nevét!",
                },
              ]}
            >
              <AutoComplete
                id="name"
                name="name"
                onChange={(value, option) =>
                  this.props.changeName(value, option)
                }
                onSelect={this.props.selectName}
                value={this.props.name}
                onFocus={this.props.setInputName}
                allowClear
              >
                {this.state.institutions.map((institute) => {
                  return (
                    <AutoComplete.Option
                      key={institute.id}
                      value={institute.name}
                    >
                      {institute.name}
                    </AutoComplete.Option>
                  );
                })}
              </AutoComplete>
            </Form.Item>           
            <Form.Item>
              <Button type="primary" htmlType="submit" danger>
                Következő
              </Button>
            </Form.Item>
          </Form>     */}
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({});
const BasicDataInstitution = connect(
  mapStateToProps,
  mapDispatchToProps
)(ConnectedBasicDataInstitution);
export default BasicDataInstitution;
